export const RIPS_DETAIL_HEADER = 'RIPS_DETAIL_HEADER'
export const CLEAR_RIPS_DETAIL = 'CLEAR_RIPS_DETAIL'
export const RIPS_DETAIL_LOADING = 'RIPS_DETAIL_LOADING'
export const RIPS_DETAIL_SUCCESS = 'RIPS_DETAIL_SUCCESS'
export const RIPS_DETAIL_ERROR = 'RIPS_DETAIL_ERROR'
export const CLEAR_RIPS_DETAIL_BODY = 'CLEAR_RIPS_DETAIL_BODY'
export const RIPS_RESULT_LOADING = 'RIPS_RESULT_LOADING'
export const RIPS_RESULT_SUCCESS = 'RIPS_RESULT_SUCCESS'
export const RIPS_RESULT_ERROR = 'RIPS_RESULT_ERROR'
export const CLEAR_RIPS_RESULT_BODY = 'CLEAR_RIPS_RESULT_BODY'
export const EMBED_URL_LOADING = 'EMBED_URL_LOADING'
export const EMBED_URL_SUCCESS = 'EMBED_URL_SUCCESS'
export const EMBED_URL_ERROR = 'EMBED_URL_ERROR'
export const CLEAR_EMBED_URL = 'CLEAR_EMBED_URL'